import React from 'react'
import { TicketsListPage } from 'page-components/auto-ticket/TicketsListPage'

export const TicketsListScreen = () => <TicketsListPage />
